import { useMatch } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Stack, Text, Anchor, Divider } from '@mantine/core';
import { PopularSection } from '../sidebar/PopularSection';
import { SuggestedUsers } from '../sidebar/SuggestedUsers';
import { AdCard } from '../sidebar/AdCard';
import { ProductDetailSidebar } from '../sidebar/ProductDetailSidebar';
import { ReviewDetailSidebar } from '../sidebar/ReviewDetailSidebar';
import { UserProfileSidebar } from '../sidebar/UserProfileSidebar';
import { CategorySidebar } from '../sidebar/CategorySidebar';
import { TagFeedSidebar } from '../sidebar/TagFeedSidebar';
import { CreateReviewSidebar } from '../sidebar/CreateReviewSidebar';

export function RightSidebar() {
  const productMatch = useMatch('/products/:id');
  const reviewMatch = useMatch('/reviews/:id');
  const reviewEditMatch = useMatch('/reviews/:id/edit');
  const reviewCreateMatch = useMatch('/reviews/create');
  const userMatch = useMatch('/users/:username');
  const categoryMatch = useMatch('/categories/:category');
  const tagMatch = useMatch('/tags/:slug');

  if (productMatch?.params.id) {
    return <ProductDetailSidebar productId={productMatch.params.id} />;
  }

  if (reviewCreateMatch || reviewEditMatch) {
    return <CreateReviewSidebar />;
  }

  if (reviewMatch?.params.id && reviewMatch.params.id !== 'create') {
    return <ReviewDetailSidebar reviewId={reviewMatch.params.id} />;
  }

  if (userMatch?.params.username) {
    return <UserProfileSidebar username={userMatch.params.username} />;
  }

  if (categoryMatch?.params.category) {
    return <CategorySidebar category={decodeURIComponent(categoryMatch.params.category)} />;
  }

  if (tagMatch?.params.slug) {
    return <TagFeedSidebar slug={tagMatch.params.slug} />;
  }

  // Default sidebar for home, search, tag feed, and other pages
  return (
    <Stack gap="lg">
      <PopularSection />
      <Divider />
      <SuggestedUsers />
      <AdCard />
      <Stack gap={4}>
        <Text size="xs" c="dimmed">
          <Anchor component={Link} to="/privacy" size="xs" c="dimmed">Privacy Policy</Anchor>
          {' · '}
          <Anchor component={Link} to="/terms" size="xs" c="dimmed">Terms of Service</Anchor>
        </Text>
        <Text size="xs" c="dimmed">
          As an Amazon Associate, CartCritic earns from qualifying purchases.
        </Text>
        <Text size="xs" c="dimmed">
          © {new Date().getFullYear()} CartCritic
        </Text>
      </Stack>
    </Stack>
  );
}
